import { useTranslation } from 'react-i18next'
import './Summary.css'

interface SummaryProps {
  text: string
}

export default function Summary({ text }: SummaryProps) {
  const { t } = useTranslation()
  return (
    <div className="summary">
      <h3 className="summary__label">{t('summary.title')}</h3>
      <p className="summary__body">{text}</p>
    </div>
  )
}
